'use client'

import Image from 'next/image';
import {useLinkAccount, usePrivy} from "@privy-io/react-auth";
import {useAppDispatch} from "@/lib/redux/hooks";
import {close} from "@/lib/redux/slices/menuSlice";

export default function MetaMaskConnectMenuItem() {
    const dispatch = useAppDispatch();
    const {authenticated} = usePrivy();
    const {linkWallet} = useLinkAccount({
        onSuccess: () => {
            dispatch(close());
        }
    });

    const handleConnect = async () => {
        if (authenticated) {
            linkWallet({
                walletList: ['metamask']
            });
        } else {
            console.warn("User is not authenticated. Cannot link wallet to account.");
        }
    }
    return (
        <button
            onClick={handleConnect}
            className="flex gap-6 justify-between items-center">
            <div
                className="flex justify-center items-center w-13 h-13 border border-grey-02 rounded-[5px] bg-dark-05">
                <Image
                    src={'/icons/icon-menu-wallet.svg'}
                    width={20}
                    height={20}
                    alt={""}
                    style={{
                        objectFit: 'cover'
                    }}>
                </Image>
            </div>
            <span className="text-white text-[24px] uppercase flex-1 text-left">MetaMask verbinden</span>
        </button>
    );
}